import { render, staticRenderFns } from "./ProductComfortablePage.vue?vue&type=template&id=26d5a5b9&scoped=true&"
import script from "./ProductComfortablePage.vue?vue&type=script&lang=js&"
export * from "./ProductComfortablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d5a5b9",
  null
  
)

export default component.exports